var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0131 15.2929L11.5623 10.8527C11.3669 10.6578 11.0506 10.6578 10.8552 10.8527C10.6592 11.0483 10.6592 11.3659 10.8552 11.5615L15.3043 16L10.8552 20.4385C10.6592 20.6341 10.6592 20.9517 10.8552 21.1473C11.0506 21.3422 11.367 21.3422 11.5624 21.1473L16.0131 16.7071L20.4376 21.1211C20.633 21.316 20.9493 21.316 21.1447 21.1211C21.3408 20.9255 21.3408 20.6079 21.1447 20.4123L16.7219 16L21.1448 11.5877C21.3408 11.3921 21.3408 11.0745 21.1448 10.8789C20.9494 10.684 20.633 10.684 20.4376 10.8789L16.0131 15.2929Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1fa1768c8cf60d203b10ef17619ff09e.svg";
export { ForwardRef as ReactComponent };